module.exports = __webpack_public_path__ + "img/plus-blue.7d9ec0ee.svg";